<template>
    <div>
        <oss-dialog
            v-model="dialog"
            maxWidth="1000px"
            :title="incomingOutgoingPaymentBTDialogTitle"
            :previousDisplay="displayPrevious"
            @previous="previous()"
            :actions="mainDialogActions"
            min-width="70vw"
        >
            <v-window v-model="wizardStep">
                <v-window-item :value="0">
                    <v-row
                        style="font-weight: bold; flex-wrap: nowrap"
                        :class="{ 'px-3': $vuetify.display.mobile }"
                    >
                        <v-col class="flex-grow-1 flex-shrink-0">
                            {{
                                selectedBankTransaction.wordingDisplay ||
                                selectedBankTransaction.wordingOriginal
                            }}
                        </v-col>
                        <v-col
                            :style="{
                                color: selectedBankTransaction.amout < 0 ? 'red' : '',
                            }"
                            class="d-flex justify-end align-center flex-grow-0 flex-shrink-1"
                        >
                            {{ newCommonFormatCurrency(selectedBankTransaction.amount, undefined) }}
                        </v-col>
                    </v-row>
                    <v-divider class="my-1" />
                    <template v-if="selectedBankTransaction.accountingLines">
                        <template
                            v-for="(al, index) of selectedBankTransaction.accountingLines"
                            :key="index"
                        >
                            <v-row
                                v-if="!al.accountableAccount.name.startsWith('512')"
                                class="pb-0 px-3"
                            >
                                <v-col>
                                    {{
                                        al.accountableAccount.shortDescription ||
                                        al.accountableAccount.description ||
                                        al.accountableAccount.name
                                    }}
                                </v-col>
                                <v-col
                                    :style="al.amountSigned < 0 ? 'color:red' : ''"
                                    class="d-flex justify-end"
                                >
                                    {{ newCommonFormatCurrency(al.amountSigned, undefined) }}
                                </v-col>
                            </v-row>
                        </template>
                    </template>
                    <v-row>
                        <v-col class="d-flex justify-end">
                            <v-btn
                                @click="documentDialog = true"
                                v-if="
                                    !!toValidateReconciliationId &&
                                    toValidateDocument &&
                                    linkedDocumentId
                                "
                                class="mr-2"
                                :loading="validateLoading"
                                size="small"
                            >
                                Valider le justificatif
                            </v-btn>
                            <v-btn
                                @click="deallocateBankTransactions"
                                v-if="alreadyAllocated"
                                class="mr-2"
                                size="small"
                            >
                                Retirer l'affectation
                            </v-btn>
                            <v-btn
                                @click="documentDialog = true"
                                :disabled="!linkedDocumentId && !toValidateDocument"
                                v-if="!!linkedDocumentId || !!toValidateReconciliationId"
                                size="small"
                            >
                                Voir le justificatif
                            </v-btn>
                            <v-btn
                                @click="goToChoiceStep"
                                v-else-if="!toValidateReconciliationId"
                                size="small"
                            >
                                Ajouter un justificatif
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-window-item>
                <v-window-item :value="1">
                    <v-list subheader lines="two">
                        <v-list-item
                            @click="
                                wizardStep = 2;
                                documentType = 'PURCHASE_INVOICE';
                            "
                            class="mb-2 rounded-xl"
                            :class="!$vuetify.display.mobile ? '' : 'px-2'"
                            v-if="displayPurchasesOption"
                            border
                        >
                            <v-list-item-title>Facture d'achat</v-list-item-title>

                            <template v-slot:append>
                                <v-btn-next />
                            </template>
                        </v-list-item>
                        <v-list-item
                            @click="
                                wizardStep = 2;
                                documentType = 'SALES_INVOICE';
                            "
                            class="mb-2 rounded-xl"
                            :class="!$vuetify.display.mobile ? '' : 'px-2'"
                            v-if="displaySalesOption"
                            border
                        >
                            <v-list-item-title>Facture de vente</v-list-item-title>
                            <template v-slot:append>
                                <v-btn-next />
                            </template>
                        </v-list-item>
                        <v-list-item
                            @click="
                                wizardStep = 2;
                                documentType = 'MISCELLANEOUS';
                            "
                            class="mb-2 rounded-xl"
                            :class="!$vuetify.display.mobile ? '' : 'px-2'"
                            :disabled="!enableLinkWithExistingDocument"
                            v-if="displayMiscellaneousOption"
                            border
                        >
                            <v-list-item-title>Document divers</v-list-item-title>
                            <template v-slot:append>
                                <v-btn-next />
                            </template>
                        </v-list-item>
                    </v-list>
                </v-window-item>
                <v-window-item :value="2">
                    <v-list subheader lines="two">
                        <!-- <v-list-item
                            v-if="company.incomeCategory === 'BNC'"
                            @click="wizardStep = 3"
                            class="mb-2 rounded-xl"
                            :class="!$vuetify.display.mobile ? '' : 'px-2'"
                            border
                        >
                            <v-list-item-title>{{ secondStepImportTitle }}</v-list-item-title>
                            <v-list-item-subtitle
                                v-if="
                                    documentType === 'PURCHASE_INVOICE' ||
                                    documentType === 'SALES_INVOICE'
                                "
                            >
                                Prenez une photo ou importez vos factures
                            </v-list-item-subtitle>

                            <template v-slot:append>
                                <v-btn-next />
                            </template>
                        </v-list-item> -->
                        <v-list-item
                            @click="
                                setDocumentTypeAuto();
                                wizardStep = 5;
                            "
                            class="mb-2 rounded-xl"
                            :class="!$vuetify.display.mobile ? '' : 'px-2'"
                            :disabled="!enableLinkWithExistingDocument"
                            border
                        >
                            <v-list-item-title>{{ secondStepLinkTitle }}</v-list-item-title>
                            <template v-slot:append>
                                <v-btn-next />
                            </template>
                        </v-list-item>
                        <v-list-item
                            @click="wizardStep = 4"
                            class="mb-2 rounded-xl"
                            :class="!$vuetify.display.mobile ? '' : 'px-2'"
                            v-if="
                                !alreadyAllocated &&
                                (documentType === 'PURCHASE_INVOICE' ||
                                    documentType === 'SALES_INVOICE')
                            "
                            border
                        >
                            <v-list-item-title>Affecter sans facture</v-list-item-title>
                            <template v-slot:append>
                                <v-btn-next />
                            </template>
                        </v-list-item>
                        <!-- <v-list-item
                             :class="!$vuetify.display.mobile ? 'mb-2 oss-list-item' : 'mb-2 px-2 oss-list-item'"
                            @click.stop=wizardStep = 5">
                                    <v-list-item-title>Commission</v-list-item-title>
                            </v-list-item>
                            <v-list-item
                             :class="!$vuetify.display.mobile ? 'mb-2 oss-list-item' : 'mb-2 px-2 oss-list-item'"
                            @click.stop="wizardStep = 6">
                                    <v-list-item-title>{{amountSigned > 0 ? 'Versement du prêt':'Remboursement emprunt'}}</v-list-item-title>
                            </v-list-item> -->
                    </v-list>
                </v-window-item>
                <v-window-item :value="3">
                    <UploadDocuments
                        :showFirstPrevious="false"
                        :companyId="selectedCompany.id"
                        :documentType="documentType"
                        :documentStatus="documentStatus"
                        :multiple="false"
                        :freeTag="false"
                        :gDrive="true"
                        :showActionsBtn="true"
                        @new-document="onNewDocument"
                        v-if="amountSigned"
                    />
                </v-window-item>
                <v-window-item :value="4">
                    <IncomingOutgoingPaymentExpense
                        :companyId="selectedCompany.id"
                        :mode="mode"
                        v-if="wizardStep === 4"
                        :initGrossAmount="Math.abs(selectedBankTransaction.amount)"
                        :initDate="selectedBankTransaction.dateDebit"
                        :initTitle="selectedBankTransaction.wordingOriginal"
                        :actions="expenseActions"
                        :bankTransactionId="selectedBankTransaction.id"
                        @expenseCreated="bankTransactionUpdated()"
                    >
                    </IncomingOutgoingPaymentExpense>
                </v-window-item>
                <v-window-item :value="5">
                    <DocumentReconciliator
                        v-if="wizardStep === 5"
                        :companyId="selectedCompany.id"
                        :miscellaneousMode="documentType === 'MISCELLANEOUS' ? true : false"
                        :thirdPartyCompanyId="thirdCompanyIdForDocumentReconciliator"
                        :documentType="documentType"
                        :amountSigned="bankTransactionAmount"
                        @addAccountingLine="addAccountingLine($event)"
                        @addDocument="addDocument($event)"
                    />
                </v-window-item>
                <v-window-item :value="6"> </v-window-item>
                <v-window-item :value="7"> </v-window-item>
            </v-window>
        </oss-dialog>
        <oss-dialog
            v-model="documentDialog"
            :withoutHeader="true"
            transition="dialog-bottom-transition"
            v-if="documentDialog"
        >
            <v-row class="d-flex justify-center">
                <v-col cols="12" style="overflow-y: auto">
                    <document
                        :mode="'Reconciliation'"
                        :companyId="selectedCompany.id"
                        :id="linkedDocumentId || toValidateDocument.id"
                        :dark-mode="true"
                        @task-ended="onDocumentValidated"
                    />
                </v-col>
            </v-row>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import gql from "graphql-tag";
import { Apollo } from "@/decorators";

import { newCommonFormatCurrency } from "../../../backend/src/common/services/mathServices";

import DocumentReconciliator from "./DocumentReconciliator.vue";
import UploadDocuments from "./document/UploadDocuments.vue";
import IncomingOutgoingPaymentExpense from "./IncomingOutgoingPaymentExpense.vue";
import Document from "./document/DocumentRouter.vue";

import { DialogAction } from "../services/dialogAction";

import CREATE_RECONCILIATION_FROM_CLIENT from "../graphql/reconciliation/CreateReconciliationFromClient.gql";
import REMOVE_LINKED_ACCOUNTING_LINES from "../graphql/bankTransaction/RemoveLinkedAccountingLines.gql";
import VALIDATE_RECONCILIATION from "../graphql/reconciliation/ValidateReconciliation.gql";
import LINK_BANKTRANSACTION_AND_DOCUMENT from "../graphql/bankTransaction/LinkBankTransactionAndDocument.gql";

import { User } from "../store/store";
import { Component, Vue, toNative, Prop, Model } from "vue-facing-decorator";

@Component({
    components: {
        UploadDocuments,
        IncomingOutgoingPaymentExpense,
        Document,
        DocumentReconciliator,
    },
    emits: ["bankTransactionChanged"],
})
export class IOPBankTransactionDialog extends Vue {
    @Prop({ default: null }) selectedCompany: any;
    @Prop({ default: null }) selectedBankTransaction: any;

    @Model() value: boolean;

    enableLinkWithExistingDocument: boolean = true;

    //
    // Autonomous bnc customer
    //

    documentDialog: boolean = false;

    wizardStep = 0;

    mode: string = "bank";

    validateLoading: boolean = false;

    documentType: string = "";

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    get company() {
        return this.$store.state.selected_company;
    }

    get dialog() {
        return this.value;
    }

    set dialog(event: boolean) {
        this.value = event;
    }

    expenseActions = {
        action: new DialogAction(),
    };

    get mainDialogActions() {
        if (this.wizardStep === 4) {
            return this.expenseActions;
        }
        return null;
    }

    get isIncomingOutgoingPayment() {
        if (
            this.selectedCompany &&
            this.selectedCompany.profile &&
            this.selectedCompany.profile.accountingType === "INCOMING_OUTGOING_PAYMENT"
        ) {
            return true;
        }
        return false;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAutonomousUser() {
        return this.currentUser?.isAutonomousUser;
    }

    get incomingOutgoingPaymentBTDialogTitle() {
        if (this.wizardStep === 0) {
            return "Affectation du mouvement bancaire";
        }
        if (this.wizardStep === 1) {
            // On ne passe plus à cet étape
            // We don't pass here anymore
            return "Choix du type de document";
        }
        if (this.wizardStep === 2) {
            return "Choix de l'action";
        }
        if (this.wizardStep === 3) {
            return "Import de justificatif";
        }
        if (this.wizardStep === 4) {
            if (this.selectedBankTransaction) {
                return "Préciser la nature de l'opération";
            }
            return "Justifier ce mouvement bancaire";
        }
        if (this.wizardStep === 5) {
            return "Choix du document";
        }
        debugger; // git-ignore
        return "Mouvement bancaire";
    }

    get linkedDocumentId() {
        return this.getLinkedDocumentId(this.selectedBankTransaction);
    }

    get toValidateDocument() {
        debugger;
        if (this.reconciliation) {
            for (const al of this.reconciliation.accountingLines) {
                if (al.document?.status !== "VALIDATED") {
                    return al.document;
                }
            }
        }
        return "";
    }

    get alreadyAllocated() {
        if (
            this.selectedBankTransaction.accountingLines.length === 1 &&
            this.selectedBankTransaction.accountingLines[0].accountableAccount.name.startsWith(
                "512",
            )
        ) {
            return false;
        }
        if (
            this.candidateAccountingLines.length === 1 &&
            (this.candidateAccountingLines[0].accountableAccount.name.startsWith("471000") ||
                this.candidateAccountingLines[0].accountableAccount.name.startsWith("512"))
        ) {
            return false;
        }
        return true;
    }

    get candidateAccountingLines() {
        if (this.selectedBankTransaction) {
            // if (bt.accountingLines.length > 2) {
            //     return null
            // }
            let uniqueAL = null;
            const accountingLines = [];
            for (const al of this.selectedBankTransaction.accountingLines) {
                if (al.document) {
                    return [];
                }
                if (al.accountableAccount.name.startsWith("512")) {
                    if (!uniqueAL) {
                        uniqueAL = al;
                    }
                } else if (al.accountableAccount.name.startsWith("471000")) {
                    uniqueAL = al;
                } else {
                    accountingLines.push(al);
                }
            }
            if (!accountingLines.length && uniqueAL) {
                accountingLines.push(uniqueAL);
            }
            return accountingLines;
        }
        return [];
    }

    get toDisplayAccountingLines() {
        if (this.toValidateDocument) {
            return this.toValidateDocument.accountingLines;
        }
        return this.candidateAccountingLines;
    }

    get toValidateReconciliationId() {
        const bt = this.selectedBankTransaction;
        if (bt.reconciliation?.status?.startsWith("PENDING_VALIDATION")) {
            return bt.reconciliation.id;
        }
        for (const al of bt.accountingLines) {
            if (al.reconciliation?.status?.startsWith("PENDING_VALIDATION")) {
                return al.reconciliation.id;
            }
        }
        return "";
    }

    get displaySalesOption() {
        if (this.selectedBankTransaction?.accountingLines?.length > 1) {
            if (
                this.selectedBankTransaction.accountingLines.every((al) => al.accountableAccount.id)
            ) {
                if (
                    this.selectedBankTransaction.accountingLines.filter(
                        (al) =>
                            al.accountableAccount.name.startsWith("401") ||
                            al.accountableAccount.name.startsWith("411") ||
                            al.accountableAccount.name.startsWith("471"),
                    ).length
                ) {
                    return true;
                }
                return false;
            }
        }
        return true;
    }

    get displayPurchasesOption() {
        if (this.selectedBankTransaction?.accountingLines?.length > 1) {
            if (
                this.selectedBankTransaction.accountingLines.every((al) => al.accountableAccount.id)
            ) {
                if (
                    this.selectedBankTransaction.accountingLines.filter(
                        (al) =>
                            al.accountableAccount.name.startsWith("401") ||
                            al.accountableAccount.name.startsWith("411") ||
                            al.accountableAccount.name.startsWith("471"),
                    ).length
                ) {
                    return true;
                }
                return false;
            }
        }
        return true;
    }

    get displayMiscellaneousOption() {
        if (this.selectedBankTransaction?.accountingLines?.length > 1) {
            if (
                this.selectedBankTransaction.accountingLines.every((al) => al.accountableAccount.id)
            ) {
                if (
                    !this.selectedBankTransaction.accountingLines.filter(
                        (al) =>
                            al.accountableAccount.name.startsWith("401") ||
                            al.accountableAccount.name.startsWith("411"),
                    ).length
                ) {
                    return true;
                }
                return false;
            }
        }
        return false;
    }

    get thirdCompanyIdForDocumentReconciliator() {
        let id = "";
        const filteredAls = this.selectedBankTransaction.accountingLines.filter(
            (al) =>
                al.accountableAccount.name.startsWith("401") ||
                al.accountableAccount.name.startsWith("411"),
        );
        if (filteredAls.length) {
            id = filteredAls.find((al) => al.thirdPartyCompany?.id).thirdPartyCompany.id;
        }
        return id;
    }

    @Apollo({
        query: gql`
            query Reconciliation($id: ID!) {
                reconciliation(where: { id: $id }) {
                    id
                    accountingLines {
                        id
                        document {
                            id
                            status
                            accountingLines {
                                id
                                amountSigned
                                wording
                            }
                        }
                        bankTransaction {
                            id
                        }
                    }
                    bankTransactions {
                        id
                    }
                }
            }
        `,
        variables() {
            return {
                id: this.toValidateReconciliationId,
            };
        },
        skip() {
            return !this.toValidateReconciliationId;
        },
        debounce: 500,
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.reconciliation) {
                    this.reconciliation = data.reconciliation;
                } else {
                    this.reconciliation = null;
                }
            }
        },
    })
    reconciliation: any = null;

    beforeMount() {
        if (!!this.toValidateReconciliationId) {
            this.wizardStep = 0;
        } else if (!!this.linkedDocumentId) {
            this.wizardStep = 0;
        } else {
            this.wizardStep = this.alreadyAllocated ? 0 : 1;
        }
    }

    bankTransactionUpdated() {
        this.dialog = false;
        this.$emit("bankTransactionChanged");
    }

    async onDocumentValidated() {
        if (this.toValidateReconciliationId) {
            await this.validateReconciliation();
        }
        this.dialog = false;
        this.$emit("bankTransactionChanged");
    }

    setDocumentTypeAuto() {
        if (this.alreadyAllocated) {
            return (this.documentType = "MISCELLANEOUS");
        }
        const btAl = this.selectedBankTransaction.accountingLines.find((al) =>
            al.accountableAccount.name.startsWith("512"),
        );
        this.documentType = btAl.amountSigned > 0 ? "SALES_INVOICE" : "PURCHASE_INVOICE";
    }

    // 0: bt data
    // 1: choices (existing document, upload or without invoice)
    // 2: upload document
    // 3: witout invoice

    get displayPrevious() {
        if (!this.wizardStep) {
            return false;
        }
        if (this.wizardStep === 1 && !this.alreadyAllocated) {
            return false;
        }
        return true;
    }

    previous() {
        if (this.wizardStep) {
            if (this.wizardStep === 1) {
                this.wizardStep = 0;
            }
            if (this.wizardStep === 2) {
                if (this.alreadyAllocated) {
                    this.wizardStep = 0;
                } else {
                    this.wizardStep = 1;
                }
                this.documentType = "";
            }
            if (this.wizardStep === 3) {
                if (!this.alreadyAllocated || this.enableLinkWithExistingDocument) {
                    this.wizardStep = 2;
                } else {
                    this.wizardStep = 0;
                }
            }
            if (this.wizardStep === 4) {
                this.wizardStep = 2;
            }
            if (this.wizardStep === 5) {
                this.wizardStep = 2;
            }
            if (this.wizardStep === 6) {
                this.wizardStep = 2;
            }
            if (this.wizardStep === 7) {
                this.wizardStep = 2;
            }
        }
    }

    goToChoiceStep() {
        if (!this.alreadyAllocated || this.enableLinkWithExistingDocument) {
            this.wizardStep = 2;
        }
    }

    async deallocateBankTransactions() {
        await this.$apollo.mutate({
            mutation: REMOVE_LINKED_ACCOUNTING_LINES,
            variables: {
                ids: [this.selectedBankTransaction.id],
            },
        });
        this.selectedBankTransaction.accountingLines =
            this.selectedBankTransaction.accountingLines.filter((al) =>
                al.accountableAccount?.name?.startsWith("512"),
            );
        this.wizardStep = 1;
        this.$emit("bankTransactionChanged");
    }

    async validateReconciliation() {
        this.validateLoading = true;
        await this.$apollo.mutate({
            mutation: VALIDATE_RECONCILIATION,
            variables: {
                id: this.reconciliation.id,
            },
        });

        this.validateLoading = false;
        this.dialog = false;
        this.$emit("bankTransactionChanged");
    }

    async addAccountingLine(accountingLineItem) {
        let btAccountingLine = null;
        if (this.selectedBankTransaction?.accountingLines?.length > 1) {
            if (
                this.selectedBankTransaction?.accountingLines?.every(
                    (al) => al.accountableAccount.id,
                ) &&
                !this.selectedBankTransaction.accountingLines.filter(
                    (al) =>
                        al.accountableAccount.name.startsWith("401") ||
                        al.accountableAccount.name.startsWith("411"),
                ).length
            ) {
                btAccountingLine = this.selectedBankTransaction.accountingLines.find((al) =>
                    al.accountableAccount.name?.startsWith("512"),
                );
            }
        } else {
            btAccountingLine = this.selectedBankTransaction.accountingLines.find((al) =>
                al.accountableAccount.name?.startsWith("471000"),
            );
        }
        const al471 = this.selectedBankTransaction.accountingLines.find((al) =>
            al.accountableAccount.name?.startsWith("471000"),
        );
        const al512 = this.selectedBankTransaction.accountingLines.find((al) =>
            al.accountableAccount.name?.startsWith("512"),
        );
        if (!btAccountingLine) {
            btAccountingLine = al471?.id ? al471 : al512;
        }
        if (accountingLineItem.accountingLine?.document && this.selectedBankTransaction) {
            await this.$apollo.mutate({
                mutation: LINK_BANKTRANSACTION_AND_DOCUMENT,
                variables: {
                    documentId: accountingLineItem.accountingLine.document.id,
                    bankTransactionId: this.selectedBankTransaction.id,
                    btAccountingLineId: btAccountingLine.id,
                    documentAccountingLineId: accountingLineItem.accountingLine.id,
                    isIncomingOutgoingPayment: this.isIncomingOutgoingPayment,
                    bankTransactionDate: this.selectedBankTransaction.dateDebit,
                },
            });
            this.$emit("bankTransactionChanged");
        }
    }

    async addDocument(document) {
        if (document && this.selectedBankTransaction) {
            const al471 = this.selectedBankTransaction.accountingLines.find((al) =>
                al.accountableAccount.name?.startsWith("471000"),
            );
            const al512 = this.selectedBankTransaction.accountingLines.find((al) =>
                al.accountableAccount.name?.startsWith("512"),
            );
            await this.$apollo.mutate({
                mutation: LINK_BANKTRANSACTION_AND_DOCUMENT,
                variables: {
                    documentId: document.id,
                    bankTransactionId: this.selectedBankTransaction.id,
                    // btAccountingLine: btItem.accountingLine,
                    btAccountingLineId: al471 ? al471.id : al512.id,
                    documentAccountingLineId: document.id,
                    isIncomingOutgoingPayment: this.isIncomingOutgoingPayment,
                },
            });
            this.$emit("bankTransactionChanged");
        } else {
            debugger;
        }
    }

    //
    // upload document
    //
    async onNewDocument(document) {
        if (document?.id && this.candidateAccountingLines?.length) {
            const al512 = this.selectedBankTransaction.accountingLines.find((al) =>
                al.accountableAccount.name.startsWith("512"),
            );
            const al471 = this.selectedBankTransaction.accountingLines.find((al) =>
                al.accountableAccount.name.startsWith("471000"),
            );
            if (this.documentType === "MISCELLANEOUS") {
                await this.$apollo.mutate({
                    mutation: gql`
                        mutation UpdateAccountingLine($documentId: ID!, $accountingLineId: ID!) {
                            updateAccountingLine(
                                where: { id: $accountingLineId }
                                data: { document: { connect: { id: $documentId } } }
                            ) {
                                id
                            }
                        }
                    `,
                    variables: {
                        documentId: document.id,
                        accountingLineId: al512.id,
                    },
                });
            } else {
                const btAccountingLine = al471;
                await this.createClientReconciliation(
                    this.selectedBankTransaction,
                    btAccountingLine,
                    document.id,
                    this.isAutonomousUser,
                );
            }
            if (this.documentType === "PURCHASE_INVOICE" || this.documentType === "SALES_INVOICE") {
                const date = this.selectedBankTransaction.dateDebit;
                const wording =
                    this.selectedBankTransaction.wordingDisplay ||
                    this.selectedBankTransaction.wordingOriginal;
                // update document
                await this.$apollo.mutate({
                    mutation: gql`
                        mutation UpdateDocument(
                            $documentId: ID!
                            $date: DateTime!
                            $wording: String!
                            $grossAmountSigned: Float!
                            $grossAmount: Float!
                        ) {
                            updateDocument(
                                where: { id: $documentId }
                                data: {
                                    displayName: $wording
                                    date: $date
                                    grossAmountSigned: $grossAmountSigned
                                    grossAmount: $grossAmount
                                }
                            ) {
                                id
                            }
                        }
                    `,
                    variables: {
                        documentId: document.id,
                        date: date,
                        wording: wording,
                        grossAmountSigned: -this.amountSigned,
                        grossAmount: Math.abs(this.amountSigned),
                    },
                });
            }
            this.$emit("bankTransactionChanged");
        }
    }

    async createClientReconciliation(
        bankTransaction,
        btAccountingLine,
        documentId,
        fromClient: boolean = true,
    ) {
        const toConnectAccountingLines = [];
        const bankTransactions = [];
        const status = fromClient ? "PENDING_VALIDATION_FROM_CLIENT" : "PENDING_VALIDATION";

        const existingBTAccountingLine = btAccountingLine;
        if (!existingBTAccountingLine || !existingBTAccountingLine.id) {
            bankTransactions.push({
                id: bankTransaction.id,
            });
        } else {
            toConnectAccountingLines.push({ id: existingBTAccountingLine.id });
        }

        const result = await this.$apollo.mutate({
            mutation: CREATE_RECONCILIATION_FROM_CLIENT,
            variables: {
                companyId: this.selectedCompany.id,
                documentId: documentId,
                bankTransactions: bankTransactions,
                accountingLines: toConnectAccountingLines,
                status,
            },
        });
    }

    getLinkedDocumentId(bt) {
        if (bt) {
            for (const al of bt.accountingLines) {
                if (al.document) {
                    return al.document.id;
                }
            }
            if (!this.isIncomingOutgoingPayment) {
                if (this.reconciliation) {
                    for (const al of this.reconciliation.accountingLines) {
                        if (al.document) {
                            return al.document.id;
                        }
                    }
                }
            }
        }
        return null;
    }

    get secondStepImportTitle() {
        if (this.documentType === "PURCHASE_INVOICE") {
            return "Importer une facture d'achat";
        }
        if (this.documentType === "SALES_INVOICE") {
            return "Importer une facture de vente";
        }
        return "Importer un justificatif";
    }

    get secondStepLinkTitle() {
        if (this.documentType === "PURCHASE_INVOICE" || this.documentType === "SALES_INVOICE") {
            return "Affecter à une facture déjà importée";
        }
        return "Affecter à un justificatif déjà importé";
    }

    get bankTransactionAmount() {
        return this.selectedBankTransaction.accountingLines.find((al) =>
            al.accountableAccount.name.startsWith("512"),
        )?.amountSigned;
    }

    get amountSigned() {
        let amountSigned = 0.0;
        if (this.candidateAccountingLines?.length) {
            for (const accountingLine of this.candidateAccountingLines) {
                if (accountingLine.accountableAccount.name.startsWith("512")) {
                    amountSigned += accountingLine.amountSigned;
                } else {
                    amountSigned -= accountingLine.amountSigned;
                }
            }
        }
        return amountSigned;
    }

    get documentStatus() {
        if (this.documentType === "MISCELLANEOUS") {
            return "VALIDATED";
        }
        if (this.candidateAccountingLines.length === 1) {
            const aaName = this.candidateAccountingLines[0].accountableAccount.name;
            if (aaName.startsWith("512") || aaName.startsWith("471")) {
                return "";
            }
        }
        return "VALIDATED";
    }
}

export default toNative(IOPBankTransactionDialog);
</script>
